<select name="metric" id="metric" class="form-select custom-select" [(ngModel)]="selectedTimeZone" style="height: 45px;"
        (ngModelChange)="timeZoneUpdate($event)">
  <option *ngFor="let timeZone of timeZoneOptions" [ngValue]="timeZone">{{timeZone.label}}</option>
</select>
